import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import './index.css'
import { motion } from 'framer-motion'

const Section5 = ({handleActivePopUp, variants}) => {
  return (
    <div className='section brainSec' id='econbrain'>
    <div className="container-lg flex flexCol alignCenter relative">
        <div className="flex flexCol alignCenter width70 textCenter">
            <img className='lightSection' src={assets.light.section4v2} alt="Light" />
            <motion.img 
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className='lightBrain' src={assets.light.section4} alt="Light"
            />
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            >                
                {assets.icons.brain}   
            </motion.div>
            <motion.h2
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .5 }}
            viewport={{ once: true }}
            >
                Collaborative brain</motion.h2>
            <motion.p
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .7 }}
            viewport={{ once: true }}
            >
                Beyond a traditional team... We collaborate and incentive <strong>hundreds of developers and blockchain architects gobally</strong> to optimize, test and implement the best solutions available through a <strong>shared world of ideas and designs</strong> to build the descentralized future.
            </motion.p>
            <Button link={'#contact'} text={'Apply to ECON Brain'} handleActivePopUp={handleActivePopUp} popData='brain'/>
            <motion.span
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .9 }}
            viewport={{ once: true }}>
                In collaboration with experts working with:</motion.span>
            <div className="flex flexRow expertsLogos gap flexWrap">
                {
                    assets.experts.map((expert, index) => (
                        <motion.img
                        variants={variants}
                        initial={'initial'}
                        whileInView={'inView'}
                        transition={{ duration: 0.7, delay:(index * .3) + .5 }}
                        viewport={{ once: true }}
                        src={expert.srcImg} alt={expert.alt} key={index}/>
                    ))
                }
            </div>

        </div>
    </div>
</div>
  )
}

export default Section5